import { render, staticRenderFns } from "./AIChatBot.vue?vue&type=template&id=9f9bb6b4&scoped=true"
import script from "./AIChatBot.vue?vue&type=script&lang=js"
export * from "./AIChatBot.vue?vue&type=script&lang=js"
import style0 from "./AIChatBot.vue?vue&type=style&index=0&id=9f9bb6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9bb6b4",
  null
  
)

export default component.exports